import React from 'react';
import { Navigate } from 'react-router-dom';
import { useShouldShowHiddenFeature } from '@/hooks/useShouldShowHiddenFeature';

export const InternalOnlyRoute = ({ children }: { children: React.ReactNode }) =>
  useShouldShowHiddenFeature() ? children : <Navigate to="/" replace />;
